import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 45 45",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", { children: [
		/* @__PURE__ */ _jsx("rect", {
			x: -.3,
			y: 18.3,
			transform: "rotate(-45.001 4.905 19.575)",
			className: "icon-fill-secondary",
			width: 10.5,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: .7,
			y: 21.1,
			transform: "rotate(-45.001 10.31 22.375)",
			className: "icon-fill-secondary",
			width: 19.2,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 8.9,
			y: 21.1,
			transform: "rotate(-45.001 18.52 22.375)",
			className: "icon-fill-secondary",
			width: 19.2,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 17.1,
			y: 21.1,
			transform: "rotate(-45.001 26.73 22.375)",
			className: "icon-fill-secondary",
			width: 19.2,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 25.3,
			y: 21.1,
			transform: "rotate(-45.001 34.94 22.375)",
			className: "icon-fill-secondary",
			width: 19.2,
			height: 2.5
		}),
		/* @__PURE__ */ _jsx("rect", {
			x: 34.8,
			y: 24.2,
			transform: "rotate(-44.936 40.116 25.41)",
			className: "icon-fill-secondary",
			width: 10.6,
			height: 2.5
		})
	] }), /* @__PURE__ */ _jsx("path", {
		className: "icon-fill-primary",
		d: "M42 0H3C1.3 0 0 1.3 0 3v39c0 1.7 1.3 3 3 3h39c1.7 0 3-1.3 3-3V3c0-1.7-1.3-3-3-3zm.5 3v11.2h-19V2.5H42c.3 0 .5.2.5.5zm-40 25.3V16.7h40v11.6h-40zM3 2.5h18v11.7H2.5V3c0-.3.2-.5.5-.5zM2.5 42V30.8H21v11.7H3c-.3 0-.5-.2-.5-.5zm39.5.5H23.5V30.8h19V42c0 .3-.2.5-.5.5z"
	})]
});
export default SvgIcon;
